import React from 'react';
import { CheckCircle2Icon, XOctagonIcon } from 'lucide-react';
export function WhoIsFor() {
  return <section className="w-full py-20 px-4 bg-brand-bg" data-id="element-128">
      <div className="max-w-6xl mx-auto" data-id="element-129">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-130">
          {/* Who is FOR */}
          <div className="bg-brand-card border border-brand-green/20 rounded-2xl p-8 relative overflow-hidden" data-id="element-131">
            <div className="absolute top-0 right-0 w-32 h-32 bg-brand-green/5 rounded-full blur-2xl -translate-y-1/2 translate-x-1/2" data-id="element-132" />

            <h3 className="text-3xl text-brand-text mb-8 flex items-center gap-3 relative z-10" data-id="element-133">
              <CheckCircle2Icon className="w-8 h-8 text-brand-green" data-id="element-134" />
              ESTO ES PARA TI SI:
            </h3>

            <ul className="space-y-6 relative z-10" data-id="element-135">
              {['Apostadores cansados de perder dinero siguiendo grupos VIP de Telegram.', 'Fanáticos del fútbol que quieren profesionalizar sus apuestas y tratarlas como una inversión.', 'Personas con disciplina que buscan independencia total y no quieren depender de nadie para ganar.'].map((text, i) => <li key={i} className="flex items-start gap-3" data-id="element-136">
                  <CheckCircle2Icon className="w-6 h-6 text-brand-green shrink-0 mt-0.5" data-id="element-137" />
                  <span className="text-lg text-brand-muted" data-id="element-138">{text}</span>
                </li>)}
            </ul>
          </div>

          {/* Who is NOT FOR */}
          <div className="bg-brand-card border border-brand-red/20 rounded-2xl p-8 relative overflow-hidden" data-id="element-139">
            <div className="absolute top-0 right-0 w-32 h-32 bg-brand-red/5 rounded-full blur-2xl -translate-y-1/2 translate-x-1/2" data-id="element-140" />

            <h3 className="text-3xl text-brand-text mb-8 flex items-center gap-3 relative z-10" data-id="element-141">
              <XOctagonIcon className="w-8 h-8 text-brand-red" data-id="element-142" />
              ESTO NO ES PARA TI SI:
            </h3>

            <ul className="space-y-6 relative z-10" data-id="element-143">
              {['Gente que busca "dinero fácil" sin leer ni estudiar el método.', 'Apostadores compulsivos que no pueden controlar sus impulsos emocionales.', 'Personas que buscan "fijas" o resultados amañados.'].map((text, i) => <li key={i} className="flex items-start gap-3" data-id="element-144">
                  <XOctagonIcon className="w-6 h-6 text-brand-red shrink-0 mt-0.5" data-id="element-145" />
                  <span className="text-lg text-brand-muted" data-id="element-146">{text}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}